/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\User\UserList.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Friday July 7th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday, 2nd October 2023 02:25:49
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { Fragment, useState } from "react";
import { useNavigate } from "react-router-dom";
import Table from "Content/Table/Table";
import TableUtils from "Utils/TableFormat";
import RouterPathResolver from "Config/Router/RouterPathResolver";
import translator from "MultiLanguage/TranslationWrapper";
import Styles from "Content/User/UserList.module.css";
// import { languagePairMatchType } from "Type/languagePairMatchType";
import { UserData, UserSimple, UserStatus } from "Type/user.type";
import Lights from "./Lights/Lights";
import UserService from "Services/Users/UserService";
// import Config from "Config/Config";
import ModalConfirmation from "Content/Modals/ModalConfirmation/ModalConfirmation";
import { TableCell, TableRow } from "@mui/material";

// type formatedData = {
//     header: JSX.Element[];
//     dataForRows: {
//         header: string[];
//         correspondance: languagePairMatchType;
//         Headers: string[];
//         Items: languagePairMatchType[];
//     };
// };

type UserListProps = {
    Users: UserData[],
    nbPage: number,
    actions: boolean,
    indicators?: boolean,
    titleKey?: string,
    botPagination?: boolean,
    pagination?: boolean,
    showStatus?: boolean,
    showRole?: boolean
}

function UserList(props: UserListProps) {
    const navigate = useNavigate();
    const [openModal, setOpenModal] = useState<boolean>(false);
    const [isOkay, setIsOkay] = useState(false);
    // const keys = ["Company"];
    const keys = [];
    if (props.indicators || props.indicators === undefined)
        keys.push("");
    keys.push("LastName", "Firstname", "Email", "Commercial");
    if (props.showStatus || props.showStatus === undefined)
        keys.push("Status");
    if (props.showRole)
        keys.push("Role");
    keys.push("CellPhone");
    if (props.actions)
        keys.push("Action");
    const translateKey = "users.list.headers.";
    const myRet = TableUtils.initFormatRowCreateHeader(keys, translateKey);

    const buildIndicators = (lastConnexionDate?: string, lastOfferDate?: string) => {
        return (<div className={`${Styles.columns}`}>
                    <Lights date={lastConnexionDate !== undefined ? new Date(lastConnexionDate) : new Date(0)} />
                    <Lights date={lastOfferDate !== undefined ? new Date(lastOfferDate) : new Date(0)} />
                </div>);
    };

    const buildCommercialName = (commercialData?: UserSimple) => {
        return commercialData ? `${commercialData.FirstName} ${commercialData.LastName}` : translator.decode('dynamic.noAttrib');
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        window.location.reload();
    };

    const handleChangeStatus = (id: string) => {
        UserService.updateStatus(id, UserStatus.ARCHIVED)
        .then(() => {
            setIsOkay(true);
            setOpenModal(true);
        })
        .catch((reason) => {
            setOpenModal(true);
            console.error(reason);
        });
    };

    // const handleSendCGV = (id: string) => {
    //     UserService.resendCGV(id)
    //     .then(() => {
    //         setIsOkay(true);
    //         setOpenModal(true);
    //     })
    //     .catch((reason) => {
    //         setOpenModal(true);
    //         console.error(reason);
    //     });
    // };

    // const handleReSendVerifactionMail = (id: string) => {
    //     UserService.resendEmailVerification(id)
    //     .then(() => {
    //         setIsOkay(true);
    //         setOpenModal(true);
    //     })
    //     .catch((reason) => {
    //         setOpenModal(true);
    //         console.error(reason);
    //     });
    // };

    const buildMyRows = (myData: UserData[]) => {
        let myRows: JSX.Element[] = [];
        for (let i = 0; i < myData.length; ++i) {
            myRows.push(
                <TableRow key={i} onClick={() => navigate(`${RouterPathResolver.pathUser_BY_ID.path.replace(":id", myData[i].id)}`)}>
                    {/* <TableCell className={`${Styles.userTd}`}>{myData[i].Company.Name}</td> */}
                    {/* <TableCell className={`${Styles.userTd}`}></TableCell> */}
                    {props.indicators ?
                        <TableCell className={`${Styles.userTd}`}>{buildIndicators(myData[i].ConnexionList[0]?.Date, myData[i].Offer[0]?.Date)}</TableCell>
                        :null}
                    <TableCell className={`${Styles.userTd} ${Styles.capitalizeText}`}>{myData[i].LastName}</TableCell>
                    <TableCell className={`${Styles.userTd} ${Styles.capitalizeText}`}>{myData[i].FirstName}</TableCell>
                    <TableCell className={`${Styles.userTd}`}>{myData[i].Email}</TableCell>
                    <TableCell className={`${Styles.userTd} ${Styles.capitalizeText}`}>{buildCommercialName(myData[i].Commercial)}</TableCell>
                    {props.showStatus || props.showStatus === undefined ?
                        <TableCell className={`${Styles.userTd} ${Styles.capitalizeText}`}>{translator.decode(`dynamic.${myData[i].Status}`)}</TableCell>
                        : null}
                    {props.showRole ?
                        <TableCell className={`${Styles.userTd} ${Styles.capitalizeText}`}>{translator.decode(`users.roles.${myData[i].UserRole?.toLowerCase() ?? "unknown"}`)}</TableCell>
                        : null}
                    <TableCell className={`${Styles.userTd}`}>{myData[i].CellPhone}</TableCell>
                    {props.actions ?
                        <TableCell className={`${Styles.userTd}`}>
                            <span className={`${Styles.action}`}>
                                {/* {myData[i].Status === "PENDING" ? <button className="btn btn-outline-success" onClick={(e) => {e.stopPropagation(); e.preventDefault(); UserService.updateStatus(myData[i].id, UserStatus.VALID)}}>{translator.decode("dynamic.valid")}</button> : null } */}
                                {/* {myData[i].Status === "NEW" ?
                                <Fragment>
                                    <button className="btn btn-outline-primary" onClick={(e) => {e.stopPropagation(); handleSendCGV(myData[i].id)}}>{translator.decode("users.sendCGV")}</button>
                                    <button className="btn btn-outline-info" onClick={(e) => {e.stopPropagation(); handleReSendVerifactionMail(myData[i].id)}}>{translator.decode("users.sendVerificationLink")}</button>
                                </Fragment>
                                : null } */}
                                {myData[i].Status !== "ARCHIVED" ? <button className="btn btn-outline-danger" onClick={(e) => {e.stopPropagation(); e.preventDefault(); handleChangeStatus(myData[i].id)}}>{translator.decode("dynamic.archive")}</button> :"" }
                            </span>
                        </TableCell>
                        : null
                    }
                </TableRow>
            );
        }
        return myRows;
    };

    return(
        <Fragment>
            {
                props.titleKey ?
                <h3>{translator.decode(props.titleKey)}</h3>
                : null
            }
            <Table rows={buildMyRows(props.Users)} header={myRet.header} nbTotalElement={props.nbPage} pagination={props.pagination === undefined ? false : props.pagination} botPagination={props.botPagination === undefined ? false : props.botPagination} />
            <ModalConfirmation show={openModal} onClose={() => handleCloseModal()} closeModal={() => handleCloseModal()} isOkay={isOkay} />
        </Fragment>
    );
}

export default UserList;
